import React, { useEffect } from "react";
import { usePageTitle } from "contexts/PageTitleContext";
import ForgotPasswordResetFrame from "components/authentication/ForgotPasswordResetFrame";
import { useBrand } from "contexts/BrandContext";

const ForgotPasswordReset = () => {
  const { setPageTitle } = usePageTitle();
  const { brand } = useBrand();

  useEffect(() => {
    setPageTitle("Crear contraseña");
  }, [setPageTitle]);

  return (
    <div className="flex w-full flex-col justify-center gap-y-4 items-center">
      <img src={brand.logo} alt={brand.brandName} className="pointer-events-none object-contain h-12" />
      <ForgotPasswordResetFrame />
    </div>
  );
};

export default ForgotPasswordReset;
